import { doppeActionTypeDefineViewerMetadata } from '../../client-server-common/doppe-action-types/doppe-action-type';
import React from 'react';
import { doppeActionTypeFaq } from './doppe-action-type-faq';

export const doppeActionTypeFaqViewer = doppeActionTypeDefineViewerMetadata(doppeActionTypeFaq, {
    loadViewerComponents: async () => ({
        DoppeActionTypeFaqWidget: (await import('./doppe-action-type-faq-widget/doppe-action-type-faq-widget')).DoppeActionTypeFaqWidget,
    }),
    renderWidget: (renderProps, { DoppeActionTypeFaqWidget }) => <DoppeActionTypeFaqWidget {...renderProps} />,
});
